
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resolution-increaser",
      function () {
        return require("private-next-pages/resolution-increaser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resolution-increaser"])
      });
    }
  